module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "select-container clearfix",
    staticStyle: {
      "margin-top": "2%"
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.moaAccessWhiteApply,
      "rules": _vm.checkNull,
      "label-width": "250px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "23%"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("请务必真实填写个人信息，否则将影响安全防护效果！")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "10%",
      "margin-bottom": "15px"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("( Please be sure to fill in your personal information truthfully, otherwise it will affect the security protection effect! )")])]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "label": "账号 ( Mis ) :",
      "prop": "misId"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "placeholder": "账号 ( Mis )"
    },
    model: {
      value: (_vm.moaAccessWhiteApply.misId),
      callback: function($$v) {
        _vm.$set(_vm.moaAccessWhiteApply, "misId", $$v)
      },
      expression: "moaAccessWhiteApply.misId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "加白场景 ( Whiten the scene ):",
      "required": "",
      "prop": "scene"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.moaAccessWhiteApply.scene),
      callback: function($$v) {
        _vm.$set(_vm.moaAccessWhiteApply, "scene", $$v)
      },
      expression: "moaAccessWhiteApply.scene"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(" 短期加白( Short term whitening ) ")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(" 长期加白( Long term whitening ) ")])], 1)], 1), _vm._v(" "), (_vm.moaAccessWhiteApply.scene == 2) ? _c('el-form-item', {
    attrs: {
      "required": "",
      "label": "加白到期时间( The expiration date for the whitelist ):"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "placeholder": "选择时间",
      "picker-options": _vm.dateLineOptions
    },
    model: {
      value: (_vm.moaAccessWhiteApply.dateLine),
      callback: function($$v) {
        _vm.$set(_vm.moaAccessWhiteApply, "dateLine", $$v)
      },
      expression: "moaAccessWhiteApply.dateLine"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "操作系统 ( System ):",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.moaAccessWhiteApply.deviceOsList),
      callback: function($$v) {
        _vm.$set(_vm.moaAccessWhiteApply, "deviceOsList", $$v)
      },
      expression: "moaAccessWhiteApply.deviceOsList"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(" PC端: macOS（需要说明不能按照要求安装合规软件的原因） ( PC: macOS, the reason why compliant software cannot be installed as required needs to be explained )")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(" PC端: Windows（需要说明不能按照要求安装合规软件的原因）( PC: Windows, you need to explain why you cannot install compliant software as required ) ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 7
    }
  }, [_vm._v(" 其他 ( other ) ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "申请安全准入加白项目 ( Access Whitelist Application ):",
      "required": ""
    }
  }, [_c('el-checkbox-group', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.moaAccessWhiteApply.items),
      callback: function($$v) {
        _vm.$set(_vm.moaAccessWhiteApply, "items", $$v)
      },
      expression: "moaAccessWhiteApply.items"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": 1
    }
  }, [_vm._v(" MOA不安装加白 ( MOA not installed, add white ) ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 2
    }
  }, [_vm._v(" 杀毒软件不安装加白 ( Add whitelist if antivirus software is not installed ) ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 3
    }
  }, [_vm._v(" 数据防泄漏不安装加白 ( Data leak prevention without installation and whitelisting ) ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 4
    }
  }, [_vm._v(" MDM不安装加白 ( MDM not installed, add white ) ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 5
    }
  }, [_vm._v(" 不合规软件不卸载加白 ( Unregister non-compliant software and add it to the whitelist ) ")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": 6
    }
  }, [_vm._v(" 其他 ( other ) ")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "label": "申请原因 ( Reason for application ) :",
      "prop": "reason"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.moaAccessWhiteApply.reason),
      expression: "moaAccessWhiteApply.reason"
    }],
    staticStyle: {
      "width": "98%",
      "height": "100px",
      "border": "solid 1px #C0C0C0",
      "border-radius": "3px",
      "resize": "none"
    },
    attrs: {
      "maxlength": "2000",
      "placeholder": "申请原因 ( Reason for application )"
    },
    domProps: {
      "value": (_vm.moaAccessWhiteApply.reason)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.moaAccessWhiteApply, "reason", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "35%"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.commitMisApply(_vm.moaAccessWhiteApply)
      }
    }
  }, [_vm._v(" 提交审批 ( Submit for approval )")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c382d2ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/whiteApply.vue
// module id = 656
// module chunks = 1